import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function getHeaderOffset() {
  // falls du eine fixe Header-Höhe hast, hier anpassen:
  const varCss = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
  const fromVar = parseInt(varCss || '0', 10);
  const hardcoded = 0; // z.B. 64
  return Number.isFinite(fromVar) && fromVar > 0 ? fromVar : hardcoded;
}

function scrollWithOffset(el, offset = 0, smooth = true) {
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
}

export default function ScrollToHash() {
  const { hash, pathname, key } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = decodeURIComponent(hash.slice(1));
    const offset = getHeaderOffset();

    let attempts = 0;
    const maxAttempts = 60; // ~3s bei 50ms
    const interval = 50;

    const timer = setInterval(() => {
      attempts += 1;

      const escaped = window.CSS?.escape ? window.CSS.escape(id) : id;
      const target = document.getElementById(id) || document.getElementById(escaped) || document.querySelector(`[name="${id}"]`);

      if (target) {
        clearInterval(timer);
        requestAnimationFrame(() => scrollWithOffset(target, offset, true));
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [hash, pathname, key]);

  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, key, hash]);

  return null;
}
